// extracted by mini-css-extract-plugin
export default {"maincontainer":"editStudentModal_maincontainer__NPitA","topbar":"editStudentModal_topbar__y3xF3"};